var _style, _path, _g, _g2, _circle, _circle2, _g3, _g4, _path2, _path3, _path4, _defs, _path5, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardJoker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309.4 427.3",
    style: {
      enableBackground: "new 0 0 309.4 427.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6EEF4;}\n\t.st1{fill:#2159D1;}\n\t.st2{fill:#FFB803;}\n\t.st3{fill:#FD8F01;}\n\t.st4{fill:#00C1EC;}\n\t.st5{fill:#016AA9;}\n\t.st6{fill:#FF605E;}\n\t.st7{fill:#DA0E21;}\n\t.st8{fill:#2A6DFF;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{clip-path:url(#SVGID_00000034805698301422890270000014336902575738817679_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.7,0h-280C6.6,0,0,6.6,0,14.7v397.9c0,8.1,6.6,14.7,14.7,14.7h280c8.1,0,14.7-6.6,14.7-14.7V14.8 C309.4,6.7,302.8,0,294.7,0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.7,45.6c0,0,5.1-11.7,7.4-11.9c2.1-0.1,7.6,12.1,7.6,12.1s11.5,0.2,12.5,1.8S60,60.1,60,60.1 s3.8,13.3,2.2,14.3s-13.9-6-13.9-6s-12.9,7-14.9,5.6s2.2-15.3,2.2-15.3s-8.5-8.8-7.6-11.1C28.9,45.6,40.7,45.6,40.7,45.6 L40.7,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.8,382.3c0,0-5,11.8-7.4,11.9c-2.1,0.1-7.7-12-7.7-12s-11.9,0.1-12.9-1.5s7.8-12.7,7.8-12.7 s-3-13.1-1.5-14.3c2-1.6,13.9,5.9,13.9,5.9s12.8-7.1,14.9-5.7c2,1.4-2.1,15.3-2.1,15.3s8.6,8.8,7.7,11 C280.6,382.3,268.8,382.3,268.8,382.3L268.8,382.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.6,126.1c-5.3-0.6-18.5,24.4-25,40.1c-9,21.6-8.7,31.3-8.7,31.3l-0.5,28.3l54.5-0.4c0,0,1.9-15.3,1.9-24 s-1.8-23.1-5.9-38.2C171.1,149.2,163.9,126.8,158.6,126.1L158.6,126.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.7,103.7c-7.1-0.2-15,2.6-16.4,14c-1.3,10.3,7.6,16.3,14.6,16.5c11.6,0.4,16.9-7.9,16.9-16.7 C175.8,110,168.2,104,160.7,103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M176.5,227.4l25.4,10.8c0,0,3.7-26.8,16.1-36.7c14.2-11.4,23.4-7.5,23.4-7.5l8.9-9.6 c0,0-10.8-20.5-36.7-16.7c-24,3.6-33.6,20.2-33.6,20.2s0.7,7.6-0.7,20.6C178,219.2,176.5,227.4,176.5,227.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M240.5,185.8c-6.5,6.1-6.3,18.3,1.8,24.2c7.5,5.5,18.9,5.3,24.2-3.5c4.9-8.1,2.9-18.8-3.9-22.6 C254.5,179.5,247.6,179.1,240.5,185.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54,187.8l8.9,8.1c0,0,15-8.8,26.4,4.7c11.6,13.6,14.4,34.5,14.4,34.5l26.5-13.2c0,0-0.5-26.3-3.4-34.4 c-2.1-5.9-11.1-21.4-38.6-21.2C65.2,166.4,54,187.8,54,187.8L54,187.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M43.8,208.9c6,6.8,17.7,6.1,22.4-0.6c4.4-6.3,3.6-15-1.7-19.9c-5.4-4.9-13.6-6.5-20.5,0.3 C37.7,194.9,40.2,204.9,43.8,208.9L43.8,208.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 152.6,
    cy: 264.9,
    r: 58.8
  })), /*#__PURE__*/React.createElement("g", null, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 152.6,
    cy: 264.9,
    r: 48.6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M171.6,234.3c-11.4,0.3-20.5,9.4-20.5,19.8c0,10.4,9,19.4,20.5,19.8c11.4,0,20.5-9.4,20.5-19.8 C192,243.6,182.9,234.5,171.6,234.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M184,254.1c0-6.7-5.5-12.1-12.4-12.1s-12.4,5.4-12.4,12.1c0,6.7,5.5,12.1,12.4,12.1S184,260.7,184,254.1z "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.1,280.5c-6.1,0-10.9,4.8-10.9,10.4s4.8,10.3,10.9,10.3c6.2-0.2,10.9-4.7,10.9-10.3 C167,285.3,162.1,280.7,156.1,280.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M160.3,290.9c0-2.3-1.9-4.1-4.2-4.1s-4.2,1.8-4.2,4.1s1.9,4.1,4.2,4.1S160.3,293.1,160.3,290.9z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M140.1,248c-2.5,0-4.7,2-4.7,4.4s2.1,4.4,4.7,4.4c2.7,0,4.7-2,4.7-4.4S142.6,248,140.1,248z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M124.3,279.9c-2.5,0-4.7,2-4.7,4.4s2.1,4.4,4.7,4.4c2.7,0,4.7-2,4.7-4.4S126.9,279.9,124.3,279.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M181.3,285.7c-2.5,0-4.7,2-4.7,4.4s2.1,4.4,4.7,4.4c2.7,0,4.7-2,4.7-4.4S183.9,285.7,181.3,285.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 152.6,
    cy: 264.9,
    r: 48.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075883158949610488900000013356937708780669329_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000075883158949610488900000013356937708780669329_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M125.4,222.4c-6-0.4-11.2,4.1-11.5,9.7c-0.3,5.6,4.2,10.6,10.3,11c6.2,0.2,11.2-4.1,11.5-9.6 C136,227.8,131.4,223,125.4,222.4z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M128.9,233c0.1-2.3-1.6-4.2-3.9-4.3c-2.3-0.1-4.3,1.6-4.4,3.8c-0.1,2.3,1.6,4.2,3.9,4.3 C126.8,237,128.8,235.3,128.9,233z"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardJoker);
export default __webpack_public_path__ + "static/media/card_joker.8430911e01071a0cddf4762c70de6327.svg";
export { ForwardRef as ReactComponent };